import { render, staticRenderFns } from "./ChatButton.vue?vue&type=template&id=3b4bad57&scoped=true"
import script from "./ChatButton.vue?vue&type=script&lang=js"
export * from "./ChatButton.vue?vue&type=script&lang=js"
import style0 from "./ChatButton.vue?vue&type=style&index=0&id=3b4bad57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4bad57",
  null
  
)

export default component.exports